import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, LayoutGrid, PenTool } from 'lucide-react';

export function ArtifactStudioV3Panel({ data }) {
  const entries = data?.studio_entries || [];

  const grouped = useMemo(() => {
    const map = new Map();
    for (const e of entries) {
      const t = e.artifact_type || 'CUSTOM';
      if (!map.has(t)) map.set(t, []);
      map.get(t).push(e);
    }
    return map;
  }, [entries]);

  if (!data) return null;

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-violet-500/25 bg-violet-950/15 p-4 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2 text-sm text-violet-200">
          <PenTool className="w-4 h-4" />
          {data.total_studio_entries} Artifact Authoring Studio entries
          {data.step === '5C.3' ? (
            <span className="text-[10px] text-violet-400/70">(Step 5C.3)</span>
          ) : null}
        </div>
        <div className="flex items-center gap-2 text-sm text-slate-400">
          <LayoutGrid className="w-4 h-4" />
          React Flow editor — EDM source of truth
        </div>
      </div>

      <div className="rounded-lg border border-slate-700/60 bg-slate-900/40 p-3 text-[11px] text-slate-400 font-mono space-y-1">
        <p>5C.2 Publish → <span className="text-violet-300">5C.3 Studio</span> → ELK Layout → SVG Renderer</p>
        <p>Route: {data.studio_route_pattern}</p>
        <p>Features: {(data.features || []).join(' · ')}</p>
      </div>

      {entries.length ? (
        <div className="space-y-3">
          {[...grouped.entries()].map(([type, items]) => (
            <div key={type}>
              <p className="text-[10px] uppercase tracking-wide text-slate-500 mb-1">{type}</p>
              <ul className="space-y-1">
                {items.map((e) => (
                  <li key={e.artifact_id}>
                    <Link
                      to={e.studio_path}
                      className="flex items-center gap-2 rounded-lg border border-cyan-500/20 bg-cyan-950/10 px-3 py-2 text-sm text-cyan-100 hover:bg-cyan-950/25"
                    >
                      <span className="font-mono text-[11px] text-cyan-400/90">{e.artifact_id}</span>
                      <span className="truncate">{e.name}</span>
                      <span className="text-[10px] text-slate-500 ml-auto">v{e.current_version}</span>
                      <ExternalLink className="w-3.5 h-3.5 shrink-0 text-cyan-500/70" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-slate-500">No studio entries — run Step 5C.2 first.</p>
      )}
    </div>
  );
}
